var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 5C1.67969 5 0 6.67969 0 8.75C0 9.92969 0.554688 11.0391 1.5 11.75L18.5 24.5C19.3906 25.1641 20.6094 25.1641 21.5 24.5L38.5 11.75C39.4453 11.0391 40 9.92969 40 8.75C40 6.67969 38.3203 5 36.25 5H3.75ZM0 13.75V30C0 32.7578 2.24219 35 5 35H35C37.7578 35 40 32.7578 40 30V13.75L23 26.5C21.2187 27.8359 18.7813 27.8359 17 26.5L0 13.75Z",
    fill: "#FFFEF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.1c6285c47d0b5ebe9ca181c1c8911e03.svg";
export { ForwardRef as ReactComponent };